export enum EUserType {
  LANDLORD = 'landlord',
  RESIDENT = 'resident',
}
